<template>
  <div class="box">
    <div class="content">
      <div id="top_data_show" v-loading="isShowDataLoading">
        <div class="data_item" v-for="item in showTopDataList" :key="item.key">
          <img :src="item.imgSrc" style="width: 42px;height: 42px;"/>
          <div style="margin-left: 10px;">
            <div style="font-size: 14px;color: rgba(0,0,0,0.65);">{{ item.name }}</div>
            <div :style="{fontSize:'30px',marginTop:'4px;',color:`${item.color}`}">{{ item.data }}</div>
          </div>
        </div>
      </div>
      <div>
        <el-form
            ref="ruleFormRef"
            :model="ruleForm"
            :label-width="formLabelWidth"
            class="demo-ruleForm"
            label-position="right"
            status-icon
        >
          <div style="display: flex;flex-wrap: wrap;justify-content: flex-start;width: 88%">
            <el-form-item :label="`${$t('sending.customer.search.no')}:`" prop="taskCode">
              <el-input size="small" style="width: 200px !important;" v-model="ruleForm.taskCode"
                        @blur="trimSearchField('taskCode')"
                        :placeholder="$t('common.please.input')"/>
            </el-form-item>
            <el-form-item :label="`${$t('common.step.search.2')}:`" prop="title">
              <el-input size="small" style="width: 200px !important;" v-model="ruleForm.title"
                        @blur="trimSearchField('title')"
                        :placeholder="$t('common.please.input')"/>
            </el-form-item>
            <el-form-item :label="`${$t('common.step.txt.1')}:`">
              <el-select size="small" v-model="ruleForm.types" :placeholder="$t('common.please.select')">
                <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('sending.customer.search.massMailType')}:`"
                          prop="massMailType">
              <el-select size="small" v-model="ruleForm.massMailType" :placeholder="$t('common.please.select')">
                <el-option :label="$t('sending.customer.option.massMailType.system')" :value="1"/>
                <el-option :label="$t('sending.customer.option.massMailType.smart')" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('sending.customer.search.createName')}:`" prop="createBy"
            >
              <el-select size="small" v-model="ruleForm.createBy" :placeholder="$t('common.please.select')"
                         :default-first-option="true">
                <el-option
                    v-for="item in tableDataSelect"
                    :label="item.userName"
                    :value="item.userId"
                    :key="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('sending.customer.search.taskStatus')}:`" prop="taskStatus">
              <el-select size="small" v-model="ruleForm.taskStatus" :placeholder="$t('common.please.select')">
                <el-option :label="$t('sending.search.status1')" style="color: #9c9ea2" :value="1"/>
                <el-option :label="$t('sending.search.status2')" style="color: #5a9cf8" :value="2"/>
                <el-option :label="$t('sending.search.status3')" style="color: #dca550" :value="3"/>
                <el-option :label="$t('sending.search.status4')" style="color: #7ec050" :value="4"/>
                <el-option :label="$t('sending.search.status5')" style="color: #e47470" :value="5"/>
                <el-option :label="$t('sending.search.status6')" style="color: #9c9ea2" :value="6"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="`${$t('common.start.time')}:`" prop="taskStartTime"
                          :style="{width: formItemWidth}">
              <el-date-picker
                  size="small"
                  style="width: 100%;"
                  v-model="ruleForm.taskStartTime"
                  type="daterange"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  date-format="YYYY/MM/DD"
                  :start-placeholder="$t('sending.customer.search.startTime')"
                  :end-placeholder="$t('sending.customer.search.endTime')"
              />
            </el-form-item>
            <el-form-item :label="`${$t('common.end.time')}:`" prop="taskEndTime"
                          :style="{width: formItemWidth}">
              <el-date-picker
                  size="small"
                  style="width: 100%;"
                  v-model="ruleForm.taskEndTime"
                  type="daterange"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  date-format="YYYY/MM/DD"
                  :start-placeholder="$t('sending.customer.search.startTime')"
                  :end-placeholder="$t('sending.customer.search.endTime')"
              />
            </el-form-item>
          </div>
          <div>
            <el-form-item style="margin-right:2px;">
              <div style="display: flex">
                <el-button style="margin-right: 10px" size="small" type="primary" @click="onSubmit(ruleFormRef)">
                  {{ $t('common.query') }}
                </el-button>
                <el-button style="margin-right: 2px;" size="small" @click="resetForms(ruleFormRef)">
                  {{ $t('common.reset') }}
                </el-button>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div style="display: flex;flex-direction: column">
        <!--      top-->
        <div class="table_top">
          <div class="table_top__title">
            <div class="h2_titles">{{ $t('sending.table.title') }}</div>
            <el-icon v-if="helpEnabled" class="table_top__help" @click="openGuideManually">
              <QuestionFilled/>
            </el-icon>
          </div>
          <!--          <div style="background: #dca550;color: white;border-radius: 4px;line-height: 40px;padding: 0px 10px">为了保证用户体验和使用效率，系统数据库和配置正在全面升级中，群发模块预计24小时内完成全部升级，感谢支持</div>-->
          <div>
            <el-button
                type="danger"
                :icon="Delete"
                @click="handleClickDelete"
                style="margin-right: 12px"
                size="small"
            >{{ $t('common.delete') }}
            </el-button
            >
            <el-button size="small" type="primary" @click="createNewTask">
              <img src="../../assets/sendgroup/send.png"
                   width="18"
                   style="margin-right: 8px"/>
              {{
                $t('sending.create.grouptask')
              }}
            </el-button>
          </div>
        </div>
        <!--      table-->
        <div class="table-container">
          <el-table
              ref="multipleTableRef"
              :data="tableData"
              style="width: 100%;margin-top: 16px"
              :header-cell-style="headerClassName"
              :header-cell-class-name="selectionHeaderClass"
              @selection-change="handleSelectionChange"
              @select="handleCheck"
              @select-all="handleClickSelectAll"
              v-loading="loading"
              :cell-style="rowClassName"
              :row-key="row => row.id"
              table-layout="fixed"
              id="sending_tables"
          >
            <el-table-column type="selection" width="40" :selectable="checkSelectable" :reserve-selection="true"/>
            <el-table-column
                :label="$t('sending.table.col.taskId')"
                prop="taskCode"
                :width="taskListColumnWidths.taskCode"
                header-align="left"
                align="left"
                class-name="task-code-column"
                label-class-name="task-code-column"
            >
              <template #default="{row}">
                <router-link
                    v-if="row.taskStatus !== 6"
                    :to="'/email/customer/senddetail/' + row.id+`/${row.massMailType}/${row.taskCode}/${row.userId}`"
                    style="color: #409eff"
                >
                  <el-button link type="primary">{{ row.taskCode }}</el-button>
                </router-link>
                <span v-else style="padding: 4px;">{{ row.taskCode }}</span>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('common.step.search.2')"
                prop="taskName"
                min-width="180"
            >
              <template #default="{row}">
                <el-tooltip
                    placement="top"
                    :show-after="1200"
                    popper-class="remark-tooltip"
                    :content="row.taskName"
                    :disabled="!row.taskName"
                >
                  <span class="task-name-cell">{{ row.taskName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!--            营销类型-->
            <el-table-column :label="$t('common.step.txt.1')" prop="massMarketType"
                             :width="taskListColumnWidths.massMarketType"
                             class-name="marketing-type-column"
                             label-class-name="marketing-type-column">
              <template #default="{row}">
                <template v-if="row.massMarketType===1">{{ $t('common.step.txt.select.1') }}</template>
                <template v-if="row.massMarketType===2">{{ $t('common.step.txt.select.2') }}</template>
                <template v-if="row.massMarketType===3">{{ $t('common.step.txt.select.3') }}</template>
                <template v-if="row.massMarketType===4">{{ $t('common.step.txt.select.4') }}</template>
                <template v-if="row.massMarketType===5">{{ $t('common.step.txt.select.5') }}</template>
                <template v-if="row.massMarketType===6">{{ $t('common.step.txt.select.6') }}</template>
                <template v-if="row.massMarketType===7">{{ $t('common.step.txt.select.7') }}</template>
                <template v-if="row.massMarketType===8">{{ $t('common.step.txt.select.8') }}</template>
              </template>
            </el-table-column>
            <!--            宽度自适应？-->
            <el-table-column :label="$t('sending.table.col.massMailType')" prop="massMailType"
                             :width="taskListColumnWidths.massMailType"
                             class-name="marketing-method-column"
                             label-class-name="marketing-method-column">
              <template #default="{row}">
                <template v-if="row.massMailType===1">{{ $t('sending.table.col.massMailType.way1') }}</template>
                <template v-if="row.massMailType===2">{{ $t('sending.table.col.massMailType.way2') }}</template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.startTime')" prop="startTime"
                             :width="taskListColumnWidths.date">
              <template #default="{ row }">
                {{ formatDateOnly(row.startTime) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.sending.over.time')" prop="endTime"
                             :width="taskListColumnWidths.date">
              <template #default="{ row }">
                {{ formatDateOnly(row.endTime) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.table.col.createName')" prop="createName"
                             :width="taskListColumnWidths.createName">
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                :label="$t('send.all.remark')"
                prop="remark"
                :width="taskListColumnWidths.remark"
            >
              <template #default="scope">
                <div class="flex items-center">
                  <el-tooltip
                      class="box-item"
                      :disabled="!scope.row.remark"
                      :content="scope.row.remark"
                      placement="right"
                      :show-after="1200"
                      popper-class="remark-tooltip"
                  >
                    <el-icon
                        @click.stop="handleClickRemark(scope.row)"
                        :color="scope.row.remark ? '#40a9ff' : '#dddddd'"
                    >
                      <Memo/>
                    </el-icon>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('sending.customer.search.taskStatus')" prop="taskStatus"
                             :width="taskListColumnWidths.taskStatus"
                             class-name="task-status-column"
                             label-class-name="task-status-column">
              <template #default="{row}">
                <div class="task-status">
                  <el-button size="small" link type="info" v-if="row.taskStatus===1" class="btn_reset">
                    {{ $t('sending.search.status1') }}
                  </el-button>
                  <el-button size="small" link type="primary" v-if="row.taskStatus===2" class="btn_reset">
                    {{ $t('sending.search.status2') }}
                  </el-button>
                  <el-button size="small" link type="warning" v-if="row.taskStatus===3" class="btn_reset">
                    {{ $t('sending.search.status3') }}
                  </el-button>
                  <el-button size="small" link type="success" v-if="row.taskStatus===4" class="btn_reset">
                    {{ $t('sending.search.status4') }}
                  </el-button>
                  <el-button size="small" link type="danger" v-if="row.taskStatus===5" class="btn_reset">
                    {{ $t('sending.search.status5') }}
                  </el-button>
                  <el-button size="small" link type="info" v-if="row.taskStatus===6" class="btn_reset">
                    {{ $t('sending.search.status6') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                :label="$t('sending.table.col.marketingStatus')"
                :width="taskListColumnWidths.marketingStatus"
                header-align="left"
                align="left"
            >
              <template #default="{row}">
                <div class="marketing-status">
                  <template v-for="item in marketingStatusItems" :key="item.prop">
                    <span class="marketing-status__item" :title="$t(item.label)">
                      <img class="marketing-status__icon" :src="item.imgSrc" :alt="$t(item.label)"/>
                      <span class="marketing-status__value" :style="{color:`${item.color}`}">{{ row[item.prop] ?? 0 }}</span>
                    </span>
                  </template>
                </div>
              </template>
            </el-table-column>
            <!--            -->
            <el-table-column :label="$t('common.operate')" prop="taskStatus"
                             align="center"
                             :width="operationColumnWidth"
                             class-name="operation-column"
                             label-class-name="operation-column"
            >
              <template #default="{row}">
                <div ref="setting" class="optionDiv">
                  <el-button v-if="row?.taskStatus===1 || row?.taskStatus===6" size="small" type="primary" link @click="handleClickEdit(row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button v-if="row?.taskStatus !== 6" size="small" type="primary" link @click="toTargetDetail(row)">{{
                      $t('common.check')
                    }}
                  </el-button>
                  <el-button v-if="row?.taskStatus!==6" size="small" type="primary" link @click="toResendGroupMail(row)">{{
                      $t('common.resend')
                    }}
                  </el-button>
                  <ConfirmDeletePopover
                      :visible="row.popoverVisibleReject"
                      :width="164"
                      :message="$t('sending.table.list.row.delete')"
                      :ref="`popover-${$index}`"
                      @update:visible="
                    (value) => (row.popoverVisibleReject = value)
                  "
                      @confirm:delete="handleClickDeleteRow(row)"
                  >
                    <template #settings>
                      <el-button
                          v-if="row.taskStatus!==2"
                          link
                          type="danger"
                          @click.native.stop="row.popoverVisibleReject = true"
                      >{{ $t('common.delete') }}
                      </el-button>
                    </template>
                  </ConfirmDeletePopover>
                  <el-button size="small" type="warning" v-if="row.taskStatus===3" link
                             @click="handleChangeStatus(row,'1')">
                    {{ $t('common.continue') }}
                  </el-button>
                  <el-button size="small" type="danger" v-if="row.taskStatus===2" link
                             @click="handleChangeStatus(row,'2')">{{ $t('common.pause') }}
                  </el-button>
                  <el-button size="small" type="danger" v-if="row.taskStatus!==4 && row.taskStatus!==5 && row.taskStatus!==6" link
                             @click="handleChangeStatus(row,'3')">{{ $t('common.cancel') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
            </template>
          </el-table>
          <div class="pages" style="margin-top: 10px">
            <Pagination v-model:modelValue="pageNo"
                        v-model:pageSizeValue="pageSize"
                        :total="totals"
                        v-if="totals"
                        ref="PageZQ"
                        :selected="selectedCount"
                        @change="handleCurrentChange"
                        @checkAllItemPage="checkAllItemPage"
                        @unCheckAllItemPage="unCheckAllItemPage"
                        @getSelect="getSelectValue"
                        :multipleSelection="multipleSelection"
                        :is-show-select="true"
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CreateTaskDia v-model="visibleDialog" v-if="visibleDialog" @close="close" :isHeadLine="false"
                 :activeItem="activeItem"></CreateTaskDia>
  <DeleteGroupTask v-if="dialogVisiblePopover" v-model="dialogVisiblePopover" @close="closeDialog"
                   :multipleSelection="multipleSelection" :getGroupMailList="getGroupMailList"
                   :isSelectAll="isSelectAll"></DeleteGroupTask>
  <!--   添加备注   -->
  <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
          :currentItem="currentItem" @getList="getGroupMailList" :task="true"></Remark>
  <!-- 功能说明轮播弹窗（helpEnabled 为 false 时整个模块不渲染） -->
  <GuideCarouselDialog
      v-if="helpEnabled"
      v-model="guideVisible"
      :title="$t('sending.guide.title')"
      :slides="guideSlides"
      :never-again-text="$t('follow.guide.never.again')"
      width="1360px"
      height="540px"
      text-height="210px"
      @never-again="handleGuideNeverAgain"
      @close-icon="handleGuideClose"
  />
</template>

<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useTransition} from '@vueuse/core'
import CreateTaskDia from "@/views/SendGroup/compontents/CreateTaskDia.vue";
import {useStore} from "vuex";
import {throttle, debouncePlus} from "@/utils/mylodash"
import {useRouter} from "vue-router";
import {emptyUrl} from "@/utils/statusParams";
import {i18n} from "@/lang";
import {Delete, QuestionFilled} from "@element-plus/icons-vue";
import DeleteGroupTask from "@/components/DiaPops/DeleteGroupTask.vue";
import {ElMessage, ElTable} from "element-plus";
import Remark from "@/components/Remark/index.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {batchDeleteMassTask} from "@/api/groupSend";
import img1 from "@/assets/yingxiao/img1@2x.png"
import img2 from "@/assets/yingxiao/img2@2x.png"
import img3 from "@/assets/yingxiao/img3@2x.png"
import img4 from "@/assets/yingxiao/img4@2x.png"
import img5 from "@/assets/yingxiao/img5@2x.png"
import {getGroupStaticData} from "@/api/customer";
import dayjs from "dayjs";
import sessionStore from "@/utils/sessionStore";
import Pagination from "@/components/Pagination/index.vue";
import GuideCarouselDialog from "@/components/GuideCarouselDialog.vue";
import guideSending1 from "@/assets/guide/sending_1.png";
import guideSending2 from "@/assets/guide/sending_2.png";
import guideSending3 from "@/assets/guide/sending_3.png";
import guideSending4 from "@/assets/guide/sending_4.png";
import guideSending5 from "@/assets/guide/sending_5.png";
import guideSending6 from "@/assets/guide/sending_6.png";
import guideSending7 from "@/assets/guide/sending_7.png";
import { shouldShowHelpDialog, markHelpDialogClosedByIcon, markHelpDialogNeverAgain, isHelpDialogEnabled } from "@/utils/helpDialog";
import { PAGE_KEYS } from "@/config/help-dialog-config";

const TIME_DELAY = 300;
const ruleForm = ref({
  taskCode: "",
  title: "",
  massMailType: "",
  createBy: "",
  targetTime: [],
  // taskTime: [],
  taskStartTime: "",
  taskEndTime: "",
  taskStatus: "",
  types: ""
})
const store = useStore()
const router = useRouter();

// 功能说明轮播弹窗
const guideVisible = ref(false)
// 帮助模块/入口开关（由 helpDialog.js 的 HELP_DIALOG_ENABLED_CONFIG 配置项控制，暂时隐藏时入口与弹窗均不渲染）
const helpEnabled = isHelpDialogEnabled(PAGE_KEYS.SENDING)
// 标记弹窗是否为“自动弹出”：仅自动弹出被关闭时才上报冷却，手动点问号打开的查看不影响冷却状态
const guideAutoShown = ref(false)
// 点击问号图标手动打开（不改变冷却状态）
const openGuideManually = () => {
  guideAutoShown.value = false
  guideVisible.value = true
}
// 轮播内容：上图下文，图片来自 src/assets/guide
const guideSlides = computed(() => [
  {image: guideSending1, title: i18n.global.t('sending.guide.slide1.title'), desc: i18n.global.t('sending.guide.slide1.desc')},
  {image: guideSending2, title: i18n.global.t('sending.guide.slide2.title'), desc: i18n.global.t('sending.guide.slide2.desc')},
  {image: guideSending3, title: i18n.global.t('sending.guide.slide3.title'), desc: i18n.global.t('sending.guide.slide3.desc')},
  {image: guideSending4, title: i18n.global.t('sending.guide.slide4.title'), desc: i18n.global.t('sending.guide.slide4.desc')},
  {image: guideSending5, title: i18n.global.t('sending.guide.slide5.title'), desc: i18n.global.t('sending.guide.slide5.desc')},
  {image: guideSending6, title: i18n.global.t('sending.guide.slide6.title'), desc: i18n.global.t('sending.guide.slide6.desc')},
  {image: guideSending7, title: i18n.global.t('sending.guide.slide7.title'), desc: i18n.global.t('sending.guide.slide7.desc')},
])
// 点击「近期不弹出」：进入 90 天冷却期（问号图标仍可手动打开）
const handleGuideNeverAgain = () => {
  markHelpDialogNeverAgain(PAGE_KEYS.SENDING)
  guideAutoShown.value = false
}
// 点击右上角关闭图标：仅在自动弹出场景下进入 7 天冷却期，避免手动查看后误缩短已有冷却期
const handleGuideClose = () => {
  if (guideAutoShown.value) {
    markHelpDialogClosedByIcon(PAGE_KEYS.SENDING)
  }
  guideAutoShown.value = false
}

const tableData = ref([])
const multipleTableRef = ref(null)

// 跨页选择相关状态
const globalSelectedRows = ref({}) // 存储每页的选中项 { pageNo: [rows] }
const isSelectAll = ref(false) // 是否全选
const isApplyingShiftSelection = ref(false) // 正在应用 Shift 区间选择
const isRestoringSelection = ref(false) // 正在通过代码恢复/清空勾选状态
const shiftAnchorIndex = ref(null) // Shift 区间选择锚点
const selectedCount = ref(0) // 选中的条数
const PageZQ = ref() // 分页组件引用


const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
const isAdmin = computed(() => store.getters["user/isAdmin"])
// 任务发起人
const tableDataSelect = computed(() => {
  if (isSuperAdmin.value || isAdmin.value) {
    return [...store.state.groups.AllTableData, {
      userName: i18n.global.t('common.all'),
      userId: 'all',
    }]
  } else {
    return store.state.groups.AllTableData
  }
});


const visibleDialog = ref(false);
const close = () => {
  visibleDialog.value = false
}
/**
 * 新建团队任务
 */
const createNewTask = () => {
  // visibleDialog.value = true;
  //   跳转到步骤 task
  // router.push(`/marketing?massOrigin=${1}`)
  sessionStore.set("marketing_time", dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"))
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {massOrigin: 1, step: 0}
  })
  window.open(routeUrl.href, '_blank')
}

/**
 * 失败数量
 * @type {Ref<UnwrapRef<number>>}
 */
const sendError = ref(0)
const sendErrorValue = useTransition(sendError, {
  duration: 1000,
})
sendError.value = 172

/**
 * 成功数量
 */
const sendSuccess = ref(0)
const sendSuccessValue = useTransition(sendSuccess, {
  duration: 1000,
})
sendSuccess.value = 300


/**
 * 打开数量
 */
const openEmail = ref(0)
const openEmailValue = useTransition(openEmail, {
  duration: 1000,
})
openEmail.value = 300


/**
 * 回复数量
 */

const reEmail = ref(0)
const reEmailValue = useTransition(reEmail, {
  duration: 1000,
});
reEmail.value = 100


//表单查询相关
const ruleFormRef = ref(null);
const startTime = ref(null);
const endTime = ref(null)

const taskStartTime = ref(null);
const taskEndTime = ref(null);

const trimSearchField = (key) => {
  if (typeof ruleForm.value[key] === 'string') {
    ruleForm.value[key] = ruleForm.value[key].trim()
  }
}

const trimSearchFormStrings = () => {
  ;['taskCode', 'title'].forEach(trimSearchField)
}

const resetForms = debouncePlus(async () => {
  ruleFormRef.value.resetFields();
  ruleForm.value.targetTime = []
  ruleForm.value.taskStartTime = null
  ruleForm.value.taskEndTime = null
  ruleForm.value.createBy = tableDataSelect.value[0].userId;
  startTime.value = null;
  endTime.value = null;
  searchForm.value = {}
  pageNo.value = 1;
  await resetInit()
  getGroupMailList()
  getGroupStatic()
}, TIME_DELAY)
const searchForm = ref({})
const onSubmit = debouncePlus(async () => {
  trimSearchFormStrings()
  const {targetTime, taskStartTime, taskEndTime, ...data} = ruleForm.value
  searchForm.value = {
    ...data,
    taskStartTime: taskStartTime && taskStartTime[0] ? `${taskStartTime[0]} 00:00:00` : null,
    taskEndTime: taskStartTime && taskStartTime[1] ? `${taskStartTime[1]} 23:59:59` : null,
    finishStartTime: taskEndTime && taskEndTime[0] ? `${taskEndTime[0]} 00:00:00` : null,
    finishEndTime: taskEndTime && taskEndTime[1] ? `${taskEndTime[1]} 23:59:59` : null
  }
  pageNo.value = 1;
  await resetInit()
  getGroupMailList()
  getGroupStatic()
}, TIME_DELAY)

// 暂停继续发送
const beginFlag = ref(false)
const handleChangeStatus = async (row, flag) => {
  const {id, taskStatus} = row
  const payload = {
    massTaskId: id,
    teamId: teamId.value
  }
  if (flag === "1") {
    //   继续
    payload.taskStatus = 2
  } else if (flag === "2") {
    //   暂停
    payload.taskStatus = 3
  } else if (flag === "3") {
    //   取消
    payload.taskStatus = 5
  }
  console.log(payload, 'payload')
  await store.dispatch("groupSend/updateMailMassStatusApis", payload)
  await getGroupMailList()
}


// 重发群发邮件
// active
const activeItem = ref(null)
const toResendGroupMail = async (row) => {
  console.log('重发', row);
  sessionStore.set("marketing_time", dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"))
  const {id} = row;
  activeItem.value = id;
  // const query = {
  //   type: row.massMailType,
  //   massTaskId: row.id,
  //   typeFlag: "reSent",
  //   mailType: "3"
  // };
  //
  // // 构造 query 字符串
  // const queryString = new URLSearchParams(query).toString();
  //
  // // 构造完整 URL（假设使用 history 模式）
  // const url = `${location.origin}/email/send_all?${queryString}`;
  // // 在新标签页打开
  // window.open(url, '_blank');
  const routeUrl = router.resolve({
    path: '/marketing',
    query: {massOrigin: row.taskStatus === 6 ? 2 : 4, taskId: id, step: 0}
  })
  window.open(routeUrl.href, '_blank')
};


// 查看email详情
const toTargetDetail = (row) => {
  if (row.taskStatus === 6) return

  console.log(row, 'row')
  const {id, massMailType, taskCode, userId} = row
  router.push(`/email/customer/senddetail/${id}/${massMailType}/${taskCode}/${userId}`)
}

const openTaskEditor = (row) => {
  // 普通草稿按原任务更新；由“暂停并修改”生成的草稿保留重发分支。
  const massOrigin = row.taskStatus === 6
    ? (Number(row.massOrigin) === 4 ? 4 : 2)
    : 2
  const query = {
    massOrigin,
    step: 0,
    taskId: row.id,
    editTaskStatus: row.taskStatus,
  }
  if (row.taskStatus === 6) {
    query.draftTaskId = row.id
  }
  const routeUrl = router.resolve({
    path: '/marketing',
    query
  })
  window.open(routeUrl.href, '_blank')
}

const handleClickEdit = (row) => {
  openTaskEditor(row)
}

// 获取文件列表
const pageNo = ref(1);
const pageSize = ref(10);
const totals = ref(0);
const loading = ref(false)

const teamId = computed(() => store.state.email.teamID);
const userInfo = computed(() => store.state.user.userInfo);
const getGroupMailList = async () => {
  let params = {
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    teamId: teamId.value,
    createBy: tableDataSelect.value[0].userId,
  }
  if (searchForm.value) {
    params = {...params, ...searchForm.value}
  }

  if (params.createBy === 'all') {
    params.createBy = '';
  }
  console.log(params, 'params')
  loading.value = true
  const res = await store.dispatch('groupSend/queryPageListApis', params)
  loading.value = false;
  const {records, total, current, size} = res;
  tableData.value = records;
  totals.value = total;
  pageNo.value = current;
}

// 判断是否是超级管理员如果是的话 就展示
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const isFirst = ref(false)
onMounted(async () => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);

  // 首次进入自动弹出功能说明（由后端下发的冷却时间控制，冷却期内不再自动弹出）
  shouldShowHelpDialog(PAGE_KEYS.SENDING).then((show) => {
    if (show) {
      guideVisible.value = true
      guideAutoShown.value = true
    }
  })

  await store.dispatch("groups/getAllUserList", {teamId: teamId.value});
  ruleForm.value.createBy = tableDataSelect.value[0].userId;
  getGroupMailList()
  if (!isFirst.value) {
    getGroupStatic()
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10 || columnIndex === 11) {
    return {
      'text-align': 'left',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  } else {
    return {
      'text-align': 'center',
      background: '#f9f9f9',
      color: 'black',
      padding: '8px 0px',
      'white-space': 'nowrap',
      'word-break': 'keep-all'
    }
  }
}

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 1 || columnIndex === 2 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10 || columnIndex === 11) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}
// 语言
const lang = computed(() => store.state.system.langLocal)
const formLabelWidth = computed(() => lang.value === 'en' ? '135px' : 'auto')
const taskListColumnWidths = computed(() => lang.value === 'en'
    ? {
      taskCode: 150,
      massMarketType: 190,
      massMailType: 180,
      date: 140,
      createName: 100,
      remark: 80,
      taskStatus: 120,
      marketingStatus: 354,
    }
    : {
      taskCode: 150,
      massMarketType: 80,
      massMailType: 80,
      date: 100,
      createName: 80,
      remark: 76,
      taskStatus: 80,
      marketingStatus: 354,
    })

const getOperationLabels = (taskStatus) => {
  const labels = []

  if (taskStatus === 1 || taskStatus === 6) labels.push(i18n.global.t('common.edit'))
  if (taskStatus !== 6) {
    labels.push(i18n.global.t('common.check'))
    labels.push(i18n.global.t('common.resend'))
  }
  if (taskStatus !== 2) labels.push(i18n.global.t('common.delete'))
  if (taskStatus === 3) labels.push(i18n.global.t('common.continue'))
  if (taskStatus === 2) labels.push(i18n.global.t('common.pause'))
  if (![4, 5, 6].includes(taskStatus)) labels.push(i18n.global.t('common.cancel'))

  return labels
}

const getOperationWidth = (labels, fontFamily) => {
  if (typeof document === 'undefined') return 230

  const context = document.createElement('canvas').getContext('2d')
  if (!context) return 230

  context.font = `13px ${fontFamily}`
  const buttonPadding = 4
  const cellPadding = 26
  const labelsWidth = labels.reduce((width, label) => width + Math.ceil(context.measureText(label).width) + buttonPadding, 0)

  return labelsWidth + cellPadding
}

const operationColumnWidth = computed(() => {
  const fontFamily = lang.value === 'en' ? 'Arial' : 'Microsoft YaHei'
  const widths = [1, 2, 3, 4, 5, 6].map((taskStatus) =>
      getOperationWidth(getOperationLabels(taskStatus), fontFamily)
  )
  const minimumWidth = lang.value === 'en' ? 260 : 160

  return Math.max(minimumWidth, getOperationWidth([i18n.global.t('common.operate')], fontFamily), ...widths)
})

watch([lang, operationColumnWidth], () => {
  nextTick(() => multipleTableRef.value?.doLayout())
}, {flush: 'post'})

const formatDateOnly = (value) => {
  if (!value) {
    return ''
  }

  if (typeof value === 'string') {
    const matchedDate = value.trim().match(/^(\d{4}-\d{2}-\d{2})/)
    if (matchedDate) {
      return matchedDate[1]
    }
  }

  const parsedDate = dayjs(value)
  return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : value
}

const formItemWidth = computed(() =>
  lang.value === 'en' ? '335px' : '278px'
)

const dialogVisiblePopover = ref(false);
const multipleSelection = ref([])

// 控制行是否可选（全选所有页时禁用单行选择）
const checkSelectable = (row) => {
  return !isSelectAll.value
}

// 跨页存在选中数据时，当前页表头选择框需要展示半选态提示
const hasAnySelectedRows = computed(() => selectedCount.value > 0 || multipleSelection.value.length > 0)

// 全选所有页时隐藏表头全选框（由分页底部的全选控制），否则正常展示
const selectionHeaderClass = ({columnIndex}) => {
  if (columnIndex === 0) {
    if (isSelectAll.value) {
      return 'disabledCheck'
    }
    return hasAnySelectedRows.value ? 'abledCheck sendingHeaderIndeterminate' : 'abledCheck'
  }
  return ''
}

const handleClickDelete = throttle((row) => {
  if (multipleSelection.value.length === 0 && !isSelectAll.value) {
    ElMessage.warning(i18n.global.t('index.sending.multiple.select'));
    return;
  }
  dialogVisiblePopover.value = true
}, 2000)

// 单行删除
const handleClickDeleteRow = async (row) => {
  if (row) {
    multipleSelection.value = [row]
  }
  const payload = {
    taskIdList: multipleSelection.value.map(item => item.id),
    teamId: teamId.value,
  }
  await batchDeleteMassTask(payload).then(res => {
    ElMessage.success(res.message)
    resetInit()
    getGroupMailList()
  }).catch(e => {
  })
}


const mergeSelectedRows = (rowsByPage) => {
  const allSelectedMap = new Map()
  Object.values(rowsByPage).flat().forEach(item => {
    if (item && item.id) {
      allSelectedMap.set(item.id, item)
    }
  })
  return Array.from(allSelectedMap.values())
}

const updateCurrentPageSelection = async (val) => {
  const currentPage = pageNo.value
  globalSelectedRows.value = {
    ...globalSelectedRows.value,
    [currentPage]: Array.isArray(val) ? val : []
  }
  const allSelected = mergeSelectedRows(globalSelectedRows.value)
  multipleSelection.value = allSelected
  selectedCount.value = isSelectAll.value ? totals.value : allSelected.length
}

const handleSelectionChange = async (val) => {
  if (isApplyingShiftSelection.value || isRestoringSelection.value) return
  console.log(val, 'handleSelectionChange - val')
  // 与 Follow.vue 保持一致：selection-change 只同步当前表格选中结果；跨页缓存由 select/select-all 显式更新
  const currentPageSelected = globalSelectedRows.value[pageNo.value] || []
  const mergedRows = mergeSelectedRows({
    ...globalSelectedRows.value,
    [pageNo.value]: currentPageSelected
  })
  multipleSelection.value = isSelectAll.value ? val : mergedRows
}

const handleCheck = async (selection, row) => {
  if (isSelectAll.value) {
    isSelectAll.value = false
    await PageZQ.value?.setIsSelectAll(false)
  }
  if (!row) {
    await updateCurrentPageSelection(selection)
    return
  }

  const clickedIndex = tableData.value.findIndex(item => item.id === row.id)
  const isRowSelectedNow = Array.isArray(selection) && selection.some(item => item.id === row.id)

  if (!isShiftPressed.value || shiftAnchorIndex.value === null || shiftAnchorIndex.value === -1 || clickedIndex === -1) {
    shiftAnchorIndex.value = clickedIndex
    await updateCurrentPageSelection(selection)
    return
  }

  const start = Math.min(shiftAnchorIndex.value, clickedIndex)
  const end = Math.max(shiftAnchorIndex.value, clickedIndex)
  isApplyingShiftSelection.value = true
  try {
    for (let i = start; i <= end; i++) {
      const r = tableData.value[i]
      if (r) {
        multipleTableRef.value?.toggleRowSelection(r, isRowSelectedNow)
      }
    }
    await nextTick(async () => {
      await updateCurrentPageSelection(multipleTableRef.value?.getSelectionRows?.() ?? selection)
    })
  } finally {
    await nextTick(() => {
      isApplyingShiftSelection.value = false
    })
  }
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值')
  await updateCurrentPageSelection(val)
}
const closeDialog = () => {
  dialogVisiblePopover.value = false;
}

// 分页相关方法
const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick()
  await nextTick()

  if (!isSelectAll.value) {
    isRestoringSelection.value = true
    try {
      multipleTableRef.value?.clearSelection()
    } finally {
      await nextTick(() => {
        isRestoringSelection.value = false
      })
    }
    globalSelectedRows.value = {}
    multipleSelection.value = []
    selectedCount.value = 0
    return
  }

  isRestoringSelection.value = true
  try {
    tableData.value.forEach((item) => {
      // 第三个参数 true：忽略 selectable，保证全选所有页时当前页禁用 checkbox 仍为蓝色选中态
      multipleTableRef.value?.toggleRowSelection(item, true, true)
    })
  } finally {
    await nextTick(() => {
      isRestoringSelection.value = false
    })
  }
  await nextTick(async () => {
    const currentSelection = multipleTableRef.value?.getSelectionRows?.() ?? []
    await updateCurrentPageSelection(currentSelection)
    selectedCount.value = totals.value
  })
}

const checkAllItemPage = async () => {
  console.log('checkAllItemPage')
  isRestoringSelection.value = true
  try {
    multipleTableRef.value?.clearSelection()
  } finally {
    await nextTick(() => {
      isRestoringSelection.value = false
    })
  }
  isSelectAll.value = true
}

const unCheckAllItemPage = async () => {
  console.log('unCheckAllItemPage')
  isRestoringSelection.value = true
  try {
    multipleTableRef.value?.clearSelection()
  } finally {
    await nextTick(() => {
      isRestoringSelection.value = false
    })
  }
  isSelectAll.value = false
  globalSelectedRows.value = {}
  multipleSelection.value = []
  selectedCount.value = 0
}

const handleCurrentChange = async (page) => {
  const {pageNo: newPageNo, pageSize: newPageSize} = page
  const isPageSizeChanged = newPageSize !== pageSize.value
  pageNo.value = newPageNo
  pageSize.value = newPageSize
  if (isPageSizeChanged) {
    await resetInit()
  }
  //  重新获取数据
  await getGroupMailList()
  // 全选
  if (isSelectAll.value) {
    await getSelectValue()
  } else {
    // 恢复当前页的选中状态
    await resetSelection()
  }
}

// 重置选择状态
const resetInit = async () => {
  isSelectAll.value = false
  try {
    await PageZQ.value?.setIsSelectAll(false)
    // 清空选项
    globalSelectedRows.value = {}
    multipleSelection.value = []
    selectedCount.value = 0
    await nextTick()
    isRestoringSelection.value = true
    try {
      multipleTableRef.value?.clearSelection()
    } finally {
      await nextTick(() => {
        isRestoringSelection.value = false
      })
    }
  } catch (e) {
    console.error(e)
  }
}

// 恢复当前页的选中状态
const resetSelection = async () => {
  await nextTick()
  await nextTick()
  const currentPage = pageNo.value
  const currentPageSelected = globalSelectedRows.value[currentPage] || []
  console.log('resetSelection - currentPage:', currentPage, 'selected:', currentPageSelected)

  if (!multipleTableRef.value) return

  if (!isSelectAll.value && currentPageSelected.length === 0) {
    isRestoringSelection.value = true
    try {
      multipleTableRef.value.clearSelection()
    } finally {
      await nextTick(() => {
        isRestoringSelection.value = false
      })
    }
    return
  }

  isRestoringSelection.value = true
  try {
    tableData.value.forEach((item) => {
      const isSelected = currentPageSelected.some((selected) => selected.id === item.id)
      // 全选所有页时忽略 selectable，保证禁用态 checkbox 仍恢复蓝色选中态
      multipleTableRef.value.toggleRowSelection(item, isSelected || isSelectAll.value, true)
    })
  } finally {
    await nextTick(() => {
      isRestoringSelection.value = false
    })
  }
}

// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};

// 监听 tableData 变化，恢复选中状态
watch(() => tableData.value, (newValue) => {
  if (newValue) {
    console.log('tableData changed, restoring selection')
    resetSelection()
  }
}, {immediate: true})


// 弹窗进行编辑备注
const visitableRemark = ref(false)
const currentItem = ref({remark: ""})
const emailListCheckoutTarget = ref({remark: ''})
const handleClickRemark = (row) => {
  const {id} = row
  console.log(id, row, 'id')
  currentItem.value = row
  visitableRemark.value = true
}
const closeRemark = () => {
  visitableRemark.value = false
}

const sendAllStaticData = ref({totalCount: 0, successCount: 0, openCount: 0, replyCount: 0, failCount: 0})
const isShowDataLoading = ref(false)
const marketingStatusItems = [
  {prop: 'massMailCount', label: 'sending.table.col.massMailCount.num', imgSrc: img1,color:"#448ef7"},
  {prop: 'successCount', label: 'sending.table.col.successCount', imgSrc: img2,color:"#7bce7b"},
  {prop: 'openCount', label: 'sending.table.col.openCount', imgSrc: img3,color:"#f19f76"},
  {prop: 'replyCount', label: 'sending.table.col.replyCount', imgSrc: img4,color:"#a386f1"},
  {prop: 'failCount', label: 'sending.table.col.failCount', imgSrc: img5,color:"#c8453f"}
]
// 顶部展示的内容
const showTopDataList = computed(() => ([
  {key: 1, name: i18n.global.t('common.edm.number'), data: sendAllStaticData.value?.totalCount, imgSrc: img1,color:"#448ef7"},
  {key: 2, name: i18n.global.t('common.edm.send'), data: sendAllStaticData.value?.successCount, imgSrc: img2,color:"#7bce7b"},
  {key: 3, name: i18n.global.t('common.edm.open'), data: sendAllStaticData.value?.openCount, imgSrc: img3,color:"#f19f76"},
  {key: 4, name: i18n.global.t('common.edm.reply'), data: sendAllStaticData.value?.replyCount, imgSrc: img4,color:"#a386f1"},
  {key: 5, name: i18n.global.t('common.edm.fail'), data: sendAllStaticData.value?.failCount, imgSrc: img5,color:"#c8453f"}
]))

const options = [
  {
    value: 1,
    label: i18n.global.t('common.step.txt.select.1'),
  },
  {
    value: 2,
    label: i18n.global.t('common.step.txt.select.2'),
  },
  {
    value: 3,
    label: i18n.global.t('common.step.txt.select.3'),
  },
  {
    value: 4,
    label: i18n.global.t('common.step.txt.select.4'),
  },
  {
    value: 5,
    label: i18n.global.t('common.step.txt.select.5'),
  },
  {
    value: 6,
    label: i18n.global.t('common.step.txt.select.6'),
  },
  {
    value: 7,
    label: i18n.global.t('common.step.txt.select.7'),
  },
  {
    value: 8,
    label: i18n.global.t('common.step.txt.select.8'),
  },
]

const getGroupStatic = async () => {
  try {
    const payload = {
      ...searchForm.value,
      teamId: teamId.value,
      // createBy: tableDataSelect.value[0].userId,
    }
    if (!payload.createBy) {
      payload.createBy = tableDataSelect.value[0].userId;
    }
    if (payload.createBy === "all") {
      payload.createBy = "";
    }

    isShowDataLoading.value = true
    const res = await getGroupStaticData(payload)
    isShowDataLoading.value = false
    console.log(res.result, 'resddddadsfa')
    sendAllStaticData.value = res?.result || {totalCount: 0, successCount: 0, openCount: 0, replyCount: 0, failCount: 0}
  } catch (e) {
    isShowDataLoading.value = false
    console.log(e)
  }
}

function renderHeader({column}) {
  // 获取操作按钮组的元素
  const opts = document.getElementsByClassName('optionDiv')
  let widthArr = []
  // 取操作组的最大宽度
  Array.prototype.forEach.call(opts, function (item) {
    if (item.innerText) {
      widthArr.push(item.offsetWidth)
    }
  })
  // 重新设置列标题及宽度属性
  if (widthArr.length > 0) {
    column.width = Math.max(...widthArr) + 30
    return column.label
  } else {
    column.width = 0
    return column.label
  }
}
</script>


<style lang="less" scoped>
@import "../../less/page.less";

.box {
  width: 100%;
  height: 100%;
  background: white;

  .top_box {
    height: 120px;
    width: 100%;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;

    .top_left {
      width: 50%;
      min-width: 580px;
      height: 100%;
      flex: 0 0 auto; /* 不压缩，不增长 */

      .content_box {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;

        .content_bottom {
          display: flex;
          justify-content: flex-start;

          & > div {
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }

          & > div:nth-of-type(1) {
            margin-left: 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }
        }
      }
    }

    .top_right {
      width: 50%;
      flex: 1 1 auto; /* 不压缩，不增长 */
      display: flex;
      justify-content: space-around;
      align-items: center;

      & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .content {
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    padding: 8px;

    & > div {
      display: flex;
      padding: 0px 10px;
    }

    & > div:nth-of-type(2) {
      width: 100%;
      min-height: 40px;
      max-height: max-content;
      padding: 6px;
      background: white;
    }

    & > div:nth-of-type(3) {
      width: 100%;
      margin-top: 8px;
      padding: 2px 6px 6px 6px;
      height: max-content !important;
      background: white;
    }
  }
}

.font {
  font-size: 16px;
  font-weight: 500;
}

.font_small {
  font-size: 12px;
  min-width: 48px;
}

.font_big {
  font-size: 22px;
  font-weight: 500;
}

.font_small_color {
  color: #b9b9b9;
}

span {
  line-height: 16px;
}

:deep(.el-button+.el-button) {
  margin-left: 0px;
}

.optionDiv {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  width: max-content;
  min-width: max-content;
  white-space: nowrap;
}

.optionDiv :deep(.el-button) {
  flex: 0 0 auto;
  margin-left: 0 !important;
}

.demo-ruleForm {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
}

:deep(.el-form-item) {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.table_top {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px;
}

.table_font {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}

.table-container {
  width: 100%;
  min-width: 0;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

:deep(.el-form-item__label) {
  font-weight: normal !important;
  font-size: 14px !important;
}

:deep(.el-range-input) {
  width: 40% !important;
}

:deep(.el-date-editor .el-range-separator) {
  flex: none !important;
}

:deep(.el-range-separator) {
  color: #a9abb1;
}

.btn_reset {
  cursor: text !important;
  pointer-events: none
}

:deep(.marketing-type-column .cell),
:deep(.marketing-method-column .cell),
:deep(.task-status-column .cell) {
  white-space: nowrap;
}

.task-status,
.marketing-status {
  display: inline-flex;
  height: 20px;
  align-items: center;
  justify-content: flex-start;
  vertical-align: middle;
}

.task-status :deep(.el-button) {
  height: 20px;
  min-height: 20px;
  padding: 0;
  line-height: 20px;
}

.marketing-status {
  min-width: max-content;
}

.marketing-status__item {
  display: inline-flex;
  flex: 0 0 66px;
  align-items: center;
  gap: 4px;
  width: 66px;
  line-height: 20px;
  white-space: nowrap;
}

.marketing-status__icon {
  display: block;
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.marketing-status__value {
  display: block;
  flex: 0 0 32px;
  width: 32px;
  min-width: 32px;
  line-height: 20px;
  text-align: left;
}

.task-name-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(#sending_tables .task-code-column .cell) {
  padding-right: 10px;
  padding-left: 10px;
}

:deep(#sending_tables .operation-column .cell) {
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
  padding-right: 16px;
  padding-left: 10px;
}

:deep(.el-form-item__label-wrap) {
  margin-left: 10px !important;
}

.h2_titles {
  font-size: 16px;
  margin-top: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

.table_top__title {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table_top__help {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  transition: color 0.2s;
}

.table_top__help:hover {
  color: var(--el-color-primary, #409eff);
}

:deep(.el-form-item__label) {
  font-weight: 700;
}

:deep(.el-select) {
  width: 200px !important;
}

:deep(.el-range-editor.el-input__wrapper) {
  padding: 0px 5px 0px 5px !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-table__header-wrapper th .cell) {
  white-space: nowrap !important;
  word-break: keep-all !important;
}

:deep(.el-button) {
  font-size: 13px !important;
}

:deep(.el-input__inner) {
  font-size: 13px !important;
}

:deep(.el-select__input) {
  font-size: 13px !important;
}

:deep(.el-form-item__label) {
  font-size: 13px !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.pages :deep(.el-pagination .el-select) {
  width: 100px !important;
}

:deep(.el-pagination) {
  position: relative !important;
  background: white !important;
  z-index: 9;
}

#top_data_show {
  background: white;
  padding: 24px 40px !important;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;

  .data_item {
    display: flex;
    height: max-content;
  }
}
/* 全选所有页时隐藏表头全选框；未全选时正常展示（与 Follow 选择逻辑保持一致） */
:deep(.disabledCheck .el-checkbox__input) {
  display: none !important;
  padding: 0 !important;
}

:deep(.abledCheck .el-checkbox__input) {
  display: block !important;
  padding: 0 !important;
}

:deep(.disabledCheck) {
  padding: 0 !important;
}

:deep(.abledCheck) {
  padding: 0 !important;
}

/* 跨页已有选择但当前页未选择时，Element Plus 默认表头框会是空白；这里补充半选态视觉提示 */
:deep(.sendingHeaderIndeterminate .el-checkbox__input:not(.is-checked):not(.is-indeterminate) .el-checkbox__inner) {
  background-color: var(--el-color-primary, #409eff) !important;
  border-color: var(--el-color-primary, #409eff) !important;
}

:deep(.sendingHeaderIndeterminate .el-checkbox__input:not(.is-checked):not(.is-indeterminate) .el-checkbox__inner::before) {
  content: '';
  position: absolute;
  display: block;
  height: 2px;
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 5px;
  background-color: #ffffff !important;
}

#sending_tables {
  :deep(.el-checkbox__input.is-disabled) {
    opacity: 1 !important;
  }

  :deep(.el-checkbox__input.is-disabled .el-checkbox__inner) {
    background-color: #ffffff !important;
    border-color: var(--el-border-color, #dcdfe6) !important;
    cursor: not-allowed !important;
  }

  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner),
  :deep(.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner) {
    background-color: var(--el-color-primary, #409eff) !important;
    border-color: var(--el-color-primary, #409eff) !important;
  }

  :deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after) {
    border-color: #ffffff !important;
  }

  :deep(.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner::before) {
    background-color: #ffffff !important;
  }
}
</style>
